<template>
  <div>
    <p class="title my-0 ml-4">売上金額 (税込み表示)</p>

    <v-row class="my-2 mx-4">
      <v-col cols="6">
        <v-select
          class="my-2"
          v-model="targetYear"
          :items="targetYearOptions"
          style="width: 200px"
          solo
          hide-details
        />
      </v-col>
      <v-col cols="6" class="d-flex justify-end align-center">
        <Button
          v-if="targetYear && invoices.length > 0"
          :click="getSalesInvoicePdfList"
          :loading="loading"
          loadingText="ダウンロード中です"
          backgroundColor="#007e57"
          small
        >
        <template v-slot:label>
          {{ targetYear }}年分の売上明細を<br />まとめてダウンロード
        </template>
        </Button>
      </v-col>
    </v-row>

    <v-list
      three-line
      class="pa-0"
    >
      <template
        v-for="(invoice, index) in invoices"
      >
        <v-list-item
          :key="index"
          class="invoice-list-item"
        >
          <v-list-item-content class="mx-4">
            <div class="item-content d-flex justify-space-between">
              <div class="left">
                <v-list-item-title class="mb-2">{{ format(invoice.start_date) }} ~ {{ format(invoice.end_date) }}</v-list-item-title>
                <v-list-item-subtitle>¥ {{ invoice.invoice_total_with_tax }}</v-list-item-subtitle>
              </div>
              <div class="middle">
                <v-chip
                  v-if="invoice.invoice_total_with_tax === 0"
                  x-small
                  label
                  color="grey lighten-1"
                  text-color="white"
                  class="pa-1"
                >
                  取引なし
                </v-chip>
              </div>
              <div class="right">
                <v-btn
                  :disabled="invoice.invoice_total_with_tax === 0"
                  @click="openPdf(invoice.start_date, invoice.end_date)" height="30px !important" x-small outlined color="secondary">
                  売上明細書を見る
                </v-btn>
              </div>
            </div>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </div>
</template>

<script>
import Button from "@/components/shared/Button.vue";
import { formatDate } from "@/plugins/i18n";

export default {
  components: {
    Button
  },

  data() {
    return {
      params: "",
      targetYear: 0,
      targetYearOptions: [],
      invoices: [],
      loading: false
    };
  },

  watch: {
    targetYear() {
      this.getPdfDataList();
    }
  },

  async created() {
    const d = new Date();
    const year = d.getFullYear();

    this.targetYear = year;
    this.getPdfDataList();
  },

  computed: {
    mobile() {
      return this.$vuetify.breakpoint.xs;
    },
    tablet() {
      return this.$vuetify.breakpoint.sm;
    }
  },

  methods: {
    format(date) {
      const d = new Date(date);
      return formatDate(d, "m月d日");
    },

    async openPdf(start_date, end_date) {
      await this.$api.get(`/farms/sales_invoice_pdf.pdf?start_date=${start_date}&end_date=${end_date}`, { responseType: "blob" }).then(response => {
        const blob = new Blob([response], { type: "application/pdf" });
        const objectUrl = URL.createObjectURL(blob);
        this.pdfsrc = objectUrl;

        window.location.href = this.pdfsrc;
      });
    },
    async getPdfDataList() {
      const res = await this.$http("get", `farms/pdf_list?year=${this.targetYear}`);

      const options = [];
      res.result.year_options.forEach(year => {
        options.push({
          text: `${year}年`,
          value: year
        });
      });

      this.invoices = res.result.pdf_data_list;
      this.targetYearOptions = options;
    },
    async getSalesInvoicePdfList() {
      this.loading = true;
      await this.$api.get(`/farms/sales_invoice_pdf_list?year=${this.targetYear}`, { responseType: "blob" }).then(response => {
        console.log("aaaaaa");
        const blob = new Blob([response], { type: "application/zip" });
        const objectUrl = URL.createObjectURL(blob);
        this.zipsrc = objectUrl;
        window.location.href = this.zipsrc;
        this.loading = false;
      });
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  width: 100%;
  text-align: left;
  font-weight: bold;
  font-size: 16px !important;
}

.invoice-list {
  &-item {
    height: 4rem;
    font: Bold 1rem Helvetica Neue;
    letter-spacing: 0.38px;
    color: #333333;
    margin: 0 auto;
    border-bottom: 1px solid #bbb;

    &:last-child {
      border-bottom: none;
    }
  }

  .item-content {
    width: 100%;

    .left {
      width: 50%;
    }

    .middle {
      width: 20%;
      padding: 20px 0;
    }

    .right {
      width: 30%;
      text-align: center;
      margin: auto;
    }
  }
}
</style>
